import * as http from '../handlers/http'

let nonce: string | null = null;
let sticky: string | null = null;

export function initSticky() {
	const result = [];
	const characters = "abcdef0123456789";
	const charactersLength = characters.length;
	for (let i = 0; i < 8; i++) {
		result.push(characters.charAt(Math.floor(Math.random() * charactersLength)));
	}
	sticky = result.join("");
}

export function getSticky(): string | null {
	return sticky;
}

export function setNonce(value: string | null) {
	nonce = value;
}

export function getNonce(): string | null {
	return nonce;
}

export function initSessionRefresh() {
	setInterval(refreshToken, 4 * 60 * 1000); // every 4 minutes
}

function refreshToken(): void {
	http.post<{ result: string }>("/web/auth/refresh")
			.then(res => setNonce(res.result))
			.catch((err) => console.error("error refreshing token", err))
}

